import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <article className="group bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-accent-300 transition-all duration-300 cursor-pointer">
      <Link to={`/article/${article.id}`} className="block">
        <div className="relative w-full h-48 overflow-hidden">
          <img
            src={article.imageUrl}
            alt={article.title}
            title={`${article.title} - 黑料bu`}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
          {article.isHot && (
            <span className="absolute top-3 left-3 bg-accent-500 text-background-50 text-xs font-semibold px-2 py-0.5 rounded-md">
              热门
            </span>
          )}
        </div>
        <div className="p-4">
          <h3 className="text-base font-semibold font-heading text-foreground-950 line-clamp-2 group-hover:text-accent-500 transition-colors mb-2 leading-snug">
            {article.title}
          </h3>
          <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed mb-3">
            {article.excerpt}
          </p>
          <div className="flex items-center justify-between text-xs text-foreground-500">
            <div className="flex items-center gap-3">
              <span className="flex items-center gap-1">
                <i className="ri-calendar-line"></i>
                {article.date}
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-eye-line"></i>
                {article.views > 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views}
              </span>
            </div>
            <div className="flex items-center gap-1 text-accent-500">
              <span>阅读全文</span>
              <i className="ri-arrow-right-line text-xs"></i>
            </div>
          </div>
        </div>
      </Link>
    </article>
  );
}